import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface BlockUserDashboardResponse extends AxiosResponse {
  data: {
    isFirstLogin: boolean
    message: string
  }
}

export interface BlockUserDashboardRequest extends Partial<AxiosRequestConfig> {
  data: {
    userId: number
    isBlock: boolean
  }
}

export function blockUserDashboardApi(
  { data, ...config }: BlockUserDashboardRequest,
  axiosInstance: AxiosInstance,
): Promise<BlockUserDashboardResponse> {
  return axiosInstance({
    data,
    method: "post",
    url: `newadmin/blockuser`,
    ...config,
  }) as Promise<BlockUserDashboardResponse>
}
